import { render, staticRenderFns } from "./BaseDotsLoaderComponent.html?vue&type=template&id=772b2271&scoped=true&"
import script from "./BaseDotsLoaderComponent.js?vue&type=script&lang=js&"
export * from "./BaseDotsLoaderComponent.js?vue&type=script&lang=js&"
import style0 from "./BaseDotsLoaderComponent.scss?vue&type=style&index=0&id=772b2271&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b2271",
  null
  
)

export default component.exports